import Yup from 'utils/validation';

export const editEngagementCampaignDetailsSchema = Yup.object({
  title: Yup.string().required('Enter campaign title.'),
  outreachDescription: Yup.string().required('Enter campaign description.')
});

export type EditEngagementCampaignDetails = Yup.InferType<
  typeof editEngagementCampaignDetailsSchema
>;
